import ChallengeState from './ChallengeState';

/**
 * Class representing a KPI challenge state.
 */
export default class KPIChallengeState extends ChallengeState {}
